import { AppSelectBox } from 'components';
import useUserRoleList from 'hooks/API/GET/useUserRoleList';
import { Fragment } from 'react';

function UserRoleDropDown({ enableAPI, value, handleChange, fieldErrors = {} }) {
  const queryParams = `?mode=dropdown`;
  const { data, isLoading, isError } = useUserRoleList({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select User Role' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option
                    key={option._id}
                    value={option._id}
                    data-role-obj={JSON.stringify(option)}
                  >
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

UserRoleDropDown.defaultProps = {
  handleChange: () => {},
};

export default UserRoleDropDown;
